<div class="main-container" data-cy="file-camera-upload-container">

  <div #webcamContainer id="webcamContainer" class="web-cam-container" [class.minimize-cam]="minimizeCamera" data-cy="file-camera-upload-webcam-container">
    <webcam [trigger]="captureImageObs"
      (initError)="handleInitError($event)"
      (imageCapture)="handleImage($event)"
      data-cy="file-camera-upload-webcam"
      [width]="videoWidth"
      [height]="videoHeight"
    ></webcam>
  </div>

  <div class="image-container" [class.minimize-cam]="!minimizeCamera" data-cy="file-camera-upload-image-container">

    <div class="spinner-container" data-cy="file-camera-upload-spinner-container">
      <mat-spinner data-cy="file-camera-upload-spinner"></mat-spinner>
    </div>

    <canvas class="snap-canvas" #canvas id="canvas" max-width="640"
    max-height="480" data-cy="file-camera-upload-canvas"></canvas>


  </div>

  <div class="action-container" data-cy="file-camera-upload-action-container">
    <button mat-raised-button color="primary"
      class="left-button"
      [disabled]="disableSnapButton"
      (click)="capturePhotoEvent()"
      data-cy="file-camera-upload-capture-button">
      Capture
    </button>

    @if (multipleWebcamsAvailable) {
      <button mat-raised-button color="primary"
        class="mid-button"
        (click)="showNextWebcam(true)"
        data-cy="file-camera-upload-prev-webcam-button">
        Prev Webcam
      </button>
    }

    @if (multipleWebcamsAvailable) {
      <button mat-raised-button color="primary"
        class="mid-button"
        (click)="showNextWebcam(true)"
        data-cy="file-camera-upload-next-webcam-button">
        Next Webcam
      </button>
    }

    <button mat-raised-button color="primary"
      class="right-button"
      (click)="close()"
      data-cy="file-camera-upload-done-button">
      Done
    </button>
  </div>

  <div class="preview-container" data-cy="file-camera-upload-preview-container">
    <!--<div class="snapshot" *ngIf="webcamImage">
    <img [src]="webcamImage.imageAsDataUrl" />
  </div>-->
</div>



</div>
